import { lazy, Suspense, useEffect, useState } from "react";
import { useLocation } from "wouter";
import { ASSISTANT_CONFIG, isEligiblePath } from "./config";
import { useActiveTimeTrigger } from "./useActiveTimeTrigger";

const SalesAssistant = lazy(() => import("./SalesAssistant"));
const ServiceEnquiryGuide = lazy(() => import("./ServiceEnquiryGuide"));

/** Tiny always-mounted gate; the interactive assistant chunk is only requested after a valid trigger. */
export default function SalesAssistantLoader() {
  const [location] = useLocation();
  const triggered = useActiveTimeTrigger(location);
  const [manualOpenId, setManualOpenId] = useState(0);

  useEffect(() => {
    const onManualOpen = () => {
      if (ASSISTANT_CONFIG.enabled && isEligiblePath(location)) setManualOpenId((current) => current + 1);
    };
    window.addEventListener("isa-open-request", onManualOpen);
    return () => window.removeEventListener("isa-open-request", onManualOpen);
  }, [location]);

  if (!isEligiblePath(location)) return null;
  // Navigation-only fallback; never mounts the AI or bypasses its enable/token checks.
  if (!ASSISTANT_CONFIG.enabled || !ASSISTANT_CONFIG.turnstileSiteKey) return <Suspense fallback={null}><ServiceEnquiryGuide /></Suspense>;
  if (!triggered && manualOpenId === 0) return null;

  return <div data-yandex-sensitive className="ym-hide-content ym-disable-keys ym-disable-submit"><Suspense fallback={null}><SalesAssistant initialTriggered={triggered} manualOpenId={manualOpenId} /></Suspense></div>;
}
